<template>
  <div>

    <v-app-bar
      class="white elevation-custom"
      :class="$vuetify.breakpoint.width < 1264 ? 'logo-gradient' : 'white'"
      flat
      app
    >
      <!-- KOMUNNALPORTAL LOGO -->
      <router-link
        v-if="$vuetify.breakpoint.width < 1264"
        :to="{ name: 'home' }"
        id="mobile-home-logo"
        class="mr-1"
      >
        <v-img class="logo" src="@/assets/logo/NEW-KoPo-Logo.svg" width="100%" contain />
      </router-link>

      <v-spacer></v-spacer>

      <div v-if="$vuetify.breakpoint.width >= 1264" class="d-flex">
        <commune-partner-card v-for="partner of communePartners" :key="partner.id" :user-commune-partner="partner" class="ml-1" />
      </div>

      <template v-if="$vuetify.breakpoint.width >= 1264">
        <div id="loginnew-dropdown"></div>
        <v-badge v-if="getUnreadNotificationsCount > 0" :content="getUnreadNotificationsCount" overlap>
        <!--<v-btn height="40px" width="40px" fab elevation="0" class="border-btn-primary" @click="onNotificationsBtnClick">
          <v-icon>mdi-email-outline</v-icon>
        </v-btn>-->
          <v-btn icon @click="onNotificationsBtnClick">
            <v-icon size="40px">$notifications</v-icon>
          </v-btn>
        </v-badge>
        <v-btn icon @click="onNotificationsBtnClick" v-else>
          <v-icon size="40px">$notifications</v-icon>
        </v-btn>
      </template>

      <!-- BURGER ICON -->
      <v-app-bar-nav-icon
        v-if="isLoggedInAndApproved"
        class="hidden-lg-and-up white--text mt-1"
        id="nav-burger-icon"
        @click="drawer = !drawer"
      />
    </v-app-bar>

    <!-- SIDE NAVIGATION CONTENT -->
    <v-navigation-drawer
      v-model="drawer"
      app
      :permanent="!useMobileMenu"
      :width="useMobileMenu ? '100vw' : 320"
      class="main-nav-drawer"
      id="nav-drawer"
    >
      <reworked-navigation-drawer />
      <v-btn style="position: absolute; top: 24px; right: 24px" icon @click="onMenuClose" v-if="useMobileMenu">
        <v-icon :class="getSelectedServiceAreaId ? [] : ['white--text'] ">mdi-close</v-icon>
      </v-btn>

      <!--<component v-bind:is="navDrawer" @showSubMenuDrawer="onSubMenuClick" />-->

    </v-navigation-drawer>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import loginNew from "loginNew";
import CommunePartnerCard from "@/components/ui/CommunePartnerCard.vue";
import ReworkedNavigationDrawer from "@/components/navigation/private/ReworkedNavigationDrawer.vue";
import {useMobileMenu} from "@/mixins/useMobileMenu";
export default {
  components: {
    CommunePartnerCard,
    ReworkedNavigationDrawer,
  },
  mixins: [useMobileMenu],
  data() {
    return {
      showSearch: false,
      menuProps: {
        // maxHeight: 200,
        dense: true,
        maxHeight: 700,
        offsetY: true,
        offsetOverflow: true,
        closeOnContentClick: true
      },
      searchQuery: "",
      searchValue: null,
      userPhotoUrl: false,
      drawer: false,
      image: require("@/assets/Sidebar_bg.png"),
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      selectedSubMenu: null
    };
  },
  watch: {
    useMobileMenu(isMobile, wasMobile) {
      if (isMobile === wasMobile) return;

      this.setSelectedServiceAreaId(null);
      this.drawer = !isMobile;
    },
    searchValue(newSearchValue) {
      if (!newSearchValue) return;
    },
    drawer(newDrawerValue) {
      if(!newDrawerValue) {
        this.setSelectedServiceAreaId(null);
      }
    }
  },
  computed: {
    ...mapGetters("user", ["userCommuneId", "getDashboardCommunePartners", "showBildungsportal"]),
    ...mapState("bildungsportal", ["contactPersons"]),
    ...mapGetters("notifications", ["getUnreadNotificationsCount"]),
    ...mapGetters("navigation", ["getSelectedServiceAreaId"]),
    showSubRoutes() {
      return this.$route.path.includes("service-area/");
    },

    communePartners() {
      if(this.showBildungsportal) return this.contactPersons;
      return this.getDashboardCommunePartners;
    },

    navDrawer() {
      if (this.showSubRoutes) return "NavigationDrawerSubRoutes";
      else if (this.selectedSubMenu) return this.selectedSubMenu;
      else return "NavigationDrawerMainRoutes";
    },

    isLoggedIn() {
      return this.$store.getters["user/isLoggedIn"];
    },

    isLoggedInAndApproved() {
      return this.isLoggedIn && this.$store.getters["user/isUserApproved"];
    },
    searchEntries() {
      const namespace = this.showBildungsportal ? "bildungsportalSearch" : "search";
      return this.$store.getters[`${namespace}/getEntries`];
    }
  },

  methods: {
    ...mapActions("notifications", ["toggleShowNotifications", "loadNotifications"]),
    ...mapActions("navigation", ["setSelectedServiceAreaId"]),
    onMenuClose() {
      this.setSelectedServiceAreaId(null);
      this.drawer = false;
    },
    onNotificationsBtnClick() {
      this.toggleShowNotifications();
    },
    onSubMenuClick(menuName) {
      this.selectedSubMenu = menuName;
    },
    // TODO: async machen, da es
    doLogout() {
      if (!process.browser) {
        return;
      }
      this.$store.dispatch("user/logout");
    },
    onItemClick(searchQuery) {
      this.searchValue = searchQuery.data;
      this.searchQuery = searchQuery.name;

      const searchNamespace = this.showBildungsportal
        ? "bildungsportalSearch"
        : "search";
      const searchPath = this.showBildungsportal
        ? "/bildungsportal/search"
        : "/search";

      this.$store.dispatch(`${searchNamespace}/setQuery`, this.searchQuery);
      this.$store.dispatch("analytics/addQuery", this.searchQuery);

      if (searchQuery.data.type === "Ansprechpartner") {
        this.$store.dispatch("analytics/commitSearchSession", {
          followUpType: "contact_person",
          followUp: searchQuery.data
        });
      }

      this.$router.push(`${searchPath}?q=${this.searchQuery}`);
    }
  },

  async mounted() {
    loginNew.init(
      "kommunalportal",
      `${process.env.VUE_APP_API_BASE_URL}/connect/login_new_ag`,
      ["google_analytics"],
      "openid email profile new_cookie usercentrics"
    );

    loginNew.onBeforeLogout(() => {
      this.doLogout();
    });

    this.drawer = !this.useMobileMenu;

    loginNew.onCookieStateChanged(() => {
      if (loginNew.serviceAllowed("eTbCyQ9d_")) {
        if (document.getElementById("usersnap-script")) return;

        const id = sessionStorage.user_id;
        const mail = sessionStorage.user_mail;

        window.onUsersnapCXLoad = function(api) {
          window.usersnapApi = api;
          api.init({
            user: {
              userId: id,
              email: mail
            }
          });
        };
        const script = document.createElement("script");
        script.id = "usersnap-script";
        script.defer = true;
        script.nonce = 'nonce-usersnap-9bcfb92c42371f30';
        script.src =
          "https://widget.usersnap.com/global/load/5adbf085-e81e-48e0-b636-f8cdbb683fcc?onload=onUsersnapCXLoad&n=nonce-usersnap-9bcfb92c42371f30";
        document.getElementsByTagName("head")[0].appendChild(script);
      } else {
        window.usersnapApi?.destroy();
        const scriptTag = document.getElementById("usersnap-script");

        if (scriptTag) {
          scriptTag.remove();
        }
      }
    });

    await this.loadNotifications();

    if (this.showBildungsportal) {
      await this.$store.dispatch("bildungsportal/loadSearchMaterials");
    }
  }
};
</script>

<style scoped>
header .v-toolbar {
  border-bottom: 6px solid red !important;
}

.login-new-avatar img {
  max-height: 35px;
  max-width: 35px;
}

.main-nav-drawer {
  background: transparent linear-gradient(22deg, #8C0F78 0%, #B40055 100%) 0% 0% no-repeat padding-box;
}

.main-nav-drawer >>> .v-navigation-drawer__content {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.main-nav-drawer >>> .v-navigation-drawer__content::-webkit-scrollbar {
  display: none;
}

/* #login-new-avatar-btn > span {
  display: var(--displayProfile);
}

#login-new-signin-btn > span {
  display: var(--displayProfile);
} */

#search-input {
  width: 50px !important;
}

#mobile-search {
  position: fixed;
  top: 65px;
  padding: 10px;
  background-color: #ffffff;
  z-index: 2;
  width: 100vw;
}

.v-text-field--outlined >>> fieldset {
  border-color: #22478a29;
}

.v-text-field--outlined:hover >>> fieldset {
  border-color: #b40055;
}
.new-sidebar-pb {
  padding-bottom: 70px !important;
}

.border-btn-primary {
  border: #B40055 solid 1px;
}
</style>
